<template>
  <div>
    <div v-if="$vuetify.breakpoint.mdAndUp">
      <div class="doctorInfoBox">
        <div class="extendableArea">
          <!--        <div class="arrowBack">-->
          <!--          <img src="../../assets/image/user-journey/arrow-narrow-right.svg" alt="">-->
          <!--        </div>-->
          <div class="personalInfoDoctor text-center mt-1">
            <img :src="therapist.user.avatar" width="160" alt="">
            <div class="nameDoctor">
              دکتر
              {{ therapist.user.full_name }}
            </div>
            <div class="titleDoctor">
              {{ therapist.subtitle }}
            </div>
            <div class="line"></div>
          </div>
          <div class="detailBox" v-if="selected_time">

            <div class="detailItem">
              <div class="iconDetail d-flex flex-column justify-center">
                <img src="../../assets/image/user-journey/calendar.svg" alt="">
              </div>
              <div class="nameDetail mx-1 d-flex flex-column justify-center">
                تاریخ جلسه:
              </div>
              <div class="valueDetail">
                {{ selected_time.from_time | jalaliDateTime }}
              </div>

            </div>
            <div class="detailItem">
              <div class="iconDetail d-flex flex-column justify-center">
                <img src="../../assets/image/user-journey/clock.svg" alt="">
              </div>
              <div class="nameDetail mx-1 d-flex flex-column justify-center">
                ساعت جلسه:
              </div>
              <div class="valueDetail">
                {{ selected_time | getDayPeriodsLabel }}

              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <v-btn text color="#30A778" class="loadMore" @click="changeStateDetail">
            تغییر زمان جلسه
          </v-btn>
        </div>
      </div>
<!--      <div class="text-center mt-5">-->
<!--        <img src="../../assets/image/user-journey/hipa.png" alt="">-->
<!--      </div>-->
    </div>
    <div v-else>
      <div class="doctorInfoBoxMobile">
        <div class="d-flex">
          <div class="d-flex flex-column justify-center">
            <img :src="therapist.user.avatar" width="85px" alt="">
          </div>
          <div class="d-flex justify-center flex-column">
            <div class="nameDoctor">
              دکتر
              {{ therapist.user.full_name }}
            </div>
            <div class="subtitle">
              {{ therapist.subTitle }}
              دکتری تخصصی روانشناسی بالینی
            </div>
          </div>
        </div>
        <div style="background: #EEE;width: 100%;height: 1px;margin: 16px 0px"></div>
        <div class="detailBox" v-if="selected_time">

          <div class="detailItem">
            <div class="iconDetail d-flex flex-column justify-center">
              <img src="../../assets/image/user-journey/calendar.svg" alt="">
            </div>
            <div class="nameDetail mx-1 d-flex flex-column justify-center">
              تاریخ جلسه:
            </div>
            <div class="valueDetail">
              {{ selected_time.from_time | jalaliDateTime }}

            </div>

          </div>
          <div class="detailItem">
            <div class="iconDetail d-flex flex-column justify-center">
              <img src="../../assets/image/user-journey/clock.svg" alt="">
            </div>
            <div class="nameDetail mx-1 d-flex flex-column justify-center">
              ساعت جلسه:
            </div>
            <div class="valueDetail">
              {{ selected_time | getDayPeriodsLabel }}

            </div>
          </div>
        </div>
        <div class="loadMore" @click="changeStateDetail">
          تغییر زمان جلسه
        </div>
      </div>

    </div>

  </div>
</template>

<script>
/*eslint-disable*/

import {mapGetters} from "vuex";
import momentJalali from "moment-jalaali";
import moment from "moment-jalaali";

export default {
  props: {
    therapist: Object,
    selected_time: Object,
  },
  data() {
    return {
      resumeSheet: false,
      isOpen: false,
    }
  },
  computed: {
    ...mapGetters({
      'profile': 'getProfile',
    }),
  },
  filters: {
    jalaliDateTime(value) {
      if (!value) return '';

      const m = momentJalali(value, "YYYY-MM-DD HH:mm");
      return m.format('jYYYY/jMM/jDD')
      // return moment(m).format('jYYYY')
      // if (!m.isValid()) return value;
      //
      // return m.locale('fa').format('jYYYY/jMM/jDD ');
    },

    getDayPeriodsLabel(time) {
      console.log(time.from_time)
      const hour = parseInt(momentJalali(time.from_time).format('HH'));
      const formated_time = momentJalali(time.from_time).format('hh:mm');
      if (hour) {
        if (hour >= 0 && hour < 12) {
          return formated_time + 'صبح'
        } else if (hour >= 12 && hour < 18) {
          return formated_time + 'عصر'
        } else if (hour >= 18 && hour <= 23) {
          return formated_time + 'شب'
        }
      }
    },
  },
  methods: {
    changeStateDetail() {
      this.$emit('backToTime')
    },
  }
}
</script>

<style scoped>
@media (min-width: 200px) and (max-width: 1000px) {
  .nameDoctor {
    font-size: 20px !important;
    text-align: right !important;
    color: #212121;
    margin-bottom: 8px;
  }

  .subtitle {
    font-size: 16px !important;
    text-align: right !important;
  }

  .detailBox {
    padding: 0px !important;
    //padding: 16px 24px !important;
  }

}

.detailBox {
  padding: 20px;
}

.titleHeader {
  font-size: 18px;
  color: #212121;
  font-weight: 500;
}

.headerResume {
  padding: 16px 24px;
  border-bottom: 1px solid var(--Bluegray-bluegray-lighten-2, #EAF0F6);


}

.actionDoctor {
  color: #035184;
  font-size: 16px;
  font-weight: 500;
}


.doctorInfoBoxMobile {
  margin-top: -10px;
  background: white;
  padding: 24px 16px;
}

.greenItemDark {
  color: #30A778 !important;
}

.doctorInfoBox {
  border-radius: 16px;
  padding: 24px;
  border: 1px solid var(--Bluegray-bluegray-lighten-3, #DBE4ED);
  background: var(--shades-white, #FFF);
}

.subtitle {
  color: #616161;
  text-align: center;
  font-size: var(--Font-Size-xl, 18px);
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.arrowBack {
  background: #EAF0F6;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  text-align: center;
}

.extendableArea {
  transition: all 0.3s;
  overflow: hidden;
  //height: 380px
}

.loadMore {
  color: #30A778;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.specialityItem {
  margin: 0px 0px 16px 8px;
  display: flex;
  height: 32px;
  padding: 0 12px;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  background: #EAF0F6;
}

.personalInfoDoctor {
  border-bottom: 1px solid #EEE;
  padding-bottom: 16px;
}

.detailDoctor {
  padding: 16px 0px 24px 0px;
  border-bottom: 1px solid #EEE;

}

.specialityDoctor {
  padding: 16px 0px 24px 0px;
  border-bottom: 1px solid #EEE;

}

.resumeHtml {
  padding: 0px 0px 24px 0px;
  height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
}

.specialityDoctor {
  padding: 16px 0px;
}

.nameDoctor {
  color: #212121;
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.titleSection {
  text-align: right;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

.activeTimeItem {
  border-color: #39C990 !important;
  transition: all 0.3s;
}

.detailItem {
  margin-bottom: 16px;
}
</style>